module.exports = __webpack_public_path__ + "img/icon_home_yw01.26a4bb56.png";